<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.title"
                :length="2"
            >
            </colored-letter-square>

            <div slot="actions" slot-scope="props">
                <main-course-table-actions
                    :data="props.row"
                    :index="props.index"
                ></main-course-table-actions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'title', 'count_variations', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    title: this.trans('courses.label.title'),
                    count_variations: this.trans(
                        'courses.label.count_variations'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['title', 'count_variations'],
            },
        };
    },

    methods: {
        fetch() {
            axios.get(this.route('mainapi.courses.index')).then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    created() {
        this.fetch();
    },

    mounted() {
        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>
